import { motion } from "framer-motion";
import { FALLBACK, pick } from "@/lib/gallery";

export default function Teachers({ gallery }) {
  const teachers = (gallery && gallery.length === 4 ? gallery : FALLBACK.pengajar).map((it, i) => ({
    name: (it?.nama && it.nama.trim()) || FALLBACK.pengajar[i]?.nama || "",
    role: (it?.jabatan && it.jabatan.trim()) || FALLBACK.pengajar[i]?.jabatan || "",
    img: pick(it?.image, FALLBACK.pengajar[i]?.image),
  }));
  return (
    <section
      id="pengajar"
      className="relative bg-sand py-24 md:py-32"
      data-testid="teachers-section"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="max-w-3xl mb-16">
          <motion.span
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.7 }}
            className="text-xs tracking-[0.4em] uppercase text-gold"
          >
            Pengajar
          </motion.span>
          <motion.h2
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8, delay: 0.1 }}
            className="mt-4 font-serif-display text-forest text-4xl md:text-5xl lg:text-6xl leading-[1.1]"
          >
            Ustadz & Ustadzah<br />
            <span className="italic text-gold">amanah, berilmu, beradab.</span>
          </motion.h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          {teachers.map((t, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.3 }}
              transition={{ duration: 0.8, delay: i * 0.1 }}
              className="group"
              data-testid={`teacher-${i}`}
            >
              <div className="relative aspect-[3/4] rounded-2xl overflow-hidden border border-gold/30">
                <img
                  src={t.img}
                  alt={t.name || t.role}
                  className="absolute inset-0 w-full h-full object-cover img-warm transition-transform duration-700 group-hover:scale-105"
                  style={{ filter: "sepia(0.08) saturate(0.95)" }}
                />
                <div className="absolute inset-0 bg-gradient-to-t from-forest/70 to-transparent opacity-60 group-hover:opacity-40 transition-opacity duration-500" />
              </div>
              <div className="mt-5">
                {t.role && <p className="text-xs tracking-[0.3em] uppercase text-gold">{t.role}</p>}
                {t.name && <h3 className="mt-2 font-serif-display text-forest text-xl leading-tight">{t.name}</h3>}
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
